import React from 'react';
import OverviewView from "./views/overview-view";
import SkillsView from "./views/skills-view";

function App() {
  return (
    <div className="App">
      <OverviewView />
      {/* <SkillsView /> */}
    </div>
  );
}

export default App;
